import { CollectionDTOInterface } from '@thewhite/react-global-module/lib/interfaces';
import { UtilService } from '@thewhite/react-global-module/lib/services';
import { action, observable } from 'mobx';
import { globalConfig } from '../../../config/globalConfig';
import OKTMO_TYPE from '../../Global/enums/oktmoType';
import { Oktmo } from '../../Global/models/oktmo';
import { OktmoActions } from '../actions/oktmoActions';

class OktmoStore {
    @observable oktmoSaveList: Oktmo[];

    constructor() {
        this.oktmoSaveList = [];
    }

    @action('add oktmo')
    addOktmo = (ids: string[]): Promise<any> => {
        let array = ids.filter(el => !!el && (!this.oktmoSaveList || this.oktmoSaveList.findIndex((child: Oktmo) => child.id === el) === -1));
        if (!array.length) {
            return Promise.resolve();
        }
        return OktmoActions.listByIds(UtilService.getUniqElementsByArray(array))
            .then((res: CollectionDTOInterface<Oktmo>) => this.oktmoSaveList = this.oktmoSaveList.length ? this.oktmoSaveList.concat(res.items) : res.items);
    }

    /**
     * Получить запись справочника имея только id
     */
    getEntityById(id: string): Oktmo | null {
        if (!this.oktmoSaveList.length) {
            return null;
        }
        let index = this.oktmoSaveList.findIndex((el: Oktmo) => el.id === id);
        if (index === -1) {
            return null;
        }
        return this.oktmoSaveList[index];
    }

    /**
     * Получить имя записи справочника имея только id
     */
    getNameById(id: string): string {
        let entity: Oktmo | null = this.getEntityById(id);
        return entity?.name ?? '';
    }

    /**
     * Получить все айдишники муниципалитетов входящих в переданый
     */
    getAllMunicipalityIdsFromParentMunicipality = (oktmo: Oktmo | null): Promise<string[]> => {
        if (!oktmo) {
            return Promise.resolve([]);
        }
        if (oktmo.code?.type?.value !== OKTMO_TYPE.MUNICIPALITY.value) {
            return Promise.resolve([oktmo.id]);
        }
        return new Promise((resolve) => {
            OktmoActions.list({
                pageNo: 0,
                pageSize: globalConfig.maxPageSize,
                municipalityId: oktmo.id,
                types: [OKTMO_TYPE.SETTLEMENT_MUNICIPALITY.value],
            })
            .then((res: CollectionDTOInterface<Oktmo>) => {
                let ids: string[] = oktmo ? [oktmo.id] : [];
                ids = ids.concat(res.items.map((el: Oktmo) => el.id));
                resolve(ids);
            })
            .catch(() => resolve(oktmo ? [oktmo.id] : []));
        });
    }
}

const oktmoStore = new OktmoStore();

export default oktmoStore;
export { OktmoStore };
